import { HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { TaskGetByIdUseCaseInterface } from 'domain/usecases';

export class RemoteTaskGetById implements TaskGetByIdUseCaseInterface {
  constructor(
    private readonly url: string,
    private readonly httpClient,
  ) {}

  async execute(
    params: TaskGetByIdUseCaseInterface.Params,
  ): Promise<TaskGetByIdUseCaseInterface.Result> {
    const httpResponse = await this.httpClient.request({
      url: this.url + '/' + params.id,
      method: 'get',
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.unauthorized:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError(httpResponse.body?.message);
    }
  }
}
